import { render, staticRenderFns } from "./OtherFooter.vue?vue&type=template&id=11c6bf52&scoped=true"
import script from "./OtherFooter.vue?vue&type=script&lang=js"
export * from "./OtherFooter.vue?vue&type=script&lang=js"
import style0 from "./OtherFooter.vue?vue&type=style&index=0&id=11c6bf52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c6bf52",
  null
  
)

export default component.exports